import type { CanRequest } from "@/hooks/use-user-permissions";

export const usersPagePermissions = "switch-user" as const satisfies CanRequest;

export const sharePagePermissions =
  "create-ref-link" as const satisfies CanRequest;

export const viewBillingAll = "view-billing-all" as const satisfies CanRequest;

export const createIngredientPagePermissions =
  "create-ingredients" as const satisfies CanRequest;

export const createTemplateIngredientPagePermissions = {
  and: ["create-ingredients", "create-template-ingredients"],
} as const satisfies CanRequest;

export const editIngredientsPagePermissions = {
  or: [createIngredientPagePermissions, "delete-ingredients"],
} as const satisfies CanRequest;

export const editTemplateIngredientsPagePermissions = {
  or: [
    createTemplateIngredientPagePermissions,
    {
      and: [
        "get-all-ingredients",
        "delete-ingredients",
        {
          or: ["delete-template-ingredients", "delete-all-ingredients"],
        },
      ],
    },
  ],
} as const satisfies CanRequest;

export const editTemplateMealsPagePermissions = {
  or: [
    {
      and: ["create-meals", "create-template-meals"],
    },
    {
      and: [
        {
          or: ["get-template-meals", "get-all-meals"],
        },
        {
          and: [
            "delete-meals",
            {
              or: ["delete-template-meals", "delete-all-meals"],
            },
          ],
        },
      ],
    },
  ],
} as const satisfies CanRequest;

export const templateMealsPagePermissions = {
  or: [
    "apply-templates",
    "get-template-meals",
    "get-all-meals",
    editTemplateMealsPagePermissions,
  ],
} as const satisfies CanRequest;

export const createTemplatePagePermissions =
  "create-templates" as const satisfies CanRequest;

export const editTemplatesPagePermissions = {
  and: ["get-all-templates", { or: ["update-templates", "delete-templates"] }],
} as const satisfies CanRequest;

export const templatesPagePermissions = {
  or: [
    "get-all-templates",
    createTemplatePagePermissions,
    editTemplatesPagePermissions,
    templateMealsPagePermissions,
  ],
} as const satisfies CanRequest;

export const editNutritionPagePermissions = {
  or: ["delete-meals", templatesPagePermissions],
} as const satisfies CanRequest;
